module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/tier-3-dfd2cd5d105dbee0cc182f1544b0c743.svg";